<template>
  <div class="tw-py-4">
    <slot />
  </div>
</template>